// extracted by mini-css-extract-plugin
export default {"nameInput":"EditProductionTypeForm_nameInput__w-Ekg","placeHolderShimmer":"EditProductionTypeForm_placeHolderShimmer__VHtU8"};